export default __webpack_public_path__ + "static/media/start-btn.a5389bf6.webp";